import { put } from "redux-saga/effects";

import { UpdateFormPageStylesRequestActionType } from "../types";
import { FormsService } from "../../../services/forms/forms.service";
import { updateFormPageStylesSuccess } from "../actionCreators";
import { getFormPageStylesChangedValues } from "../../../helpers/dataManipulations";

export function* updateFormStyles({ payload }: UpdateFormPageStylesRequestActionType) {
    try {
        yield FormsService.newUpdateForm({
            data: getFormPageStylesChangedValues(payload.prevState, payload.page),
        });
        yield put(updateFormPageStylesSuccess({}));
    } catch (error) {
        // yield put(Handle Error);
    }
}
